export const getImagePath = (path: string) => {
    if (path.startsWith("http")) return getEnvStr(path);
    return getEnvStr(`{IMG_PREFIX}${path}`);
};

export const getBackendUrl = (path?: string) => {
    if (path?.startsWith("http")) return path;
    const apiUrl = process.env.REACT_APP_API_URL || '';
    return `${apiUrl}${path?.startsWith('/') ? '' : '/'}${path || ''}`;
}

export const getEnvStr = (str: string) => {
    const env = process.env;
    if (!env) {
        console.error(".env is not exist")
        return str;
    }

    return env[`REACT_APP_${str}`] ??
        str.replace(/{([^}]+)}/g, (match, key) => env[`REACT_APP_${key}`] ?? match);
};

export const getServerImage = (path: string) => {
    return getBackendUrl(path);
}

